import React from 'react';
import ReactDOM from "react-dom/client";
import "./index.css";
import router from "./App";
import { RouterProvider } from "react-router-dom";
import reportWebVitals from "./reportWebVitals";
import ThemeProvider from "./Providers/ThemeProvider";
import Layout from "./Components/Layout/Layout";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
  <ThemeProvider>
    <Layout>
      <RouterProvider router={router} />
    </Layout>
  </ThemeProvider>
</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
